import { Component, computed, ElementRef, inject, input, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { DashboardLayoutService } from '@eforall/dashboard';
import { NgClass } from '@angular/common';

@Component({
	selector: 'toolbar',
	standalone: true,
	imports: [NgClass],
	templateUrl: './toolbar.widget.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['toolbar.widget.scss'],
})
export class ToolbarWidget {
	private layoutService = inject(DashboardLayoutService);

	private readonly toolbarDiv = viewChild<ElementRef<HTMLInputElement>>('toolbar');
	public icon = input<'Configuration' | 'Admissions' | 'VolCoordination' | 'VolRecruitment' | 'Delivery' | 'Alumni' | 'Development' | 'Experience'>();


	public isScrollable = computed(() => {
		const dimensions = this.layoutService.dimensions();
		const toolbar = this.toolbarDiv();
		if (toolbar) {
			return this.layoutService.isScrollable(toolbar.nativeElement).horizontallyScrollable;
		}

		return false;
	});

	public readonly configurationToolbar = computed(() => this.icon() == 'Configuration');
	public readonly admissionsToolbar = computed(() => this.icon() == 'Admissions');
	public readonly volCoordinationToolbar = computed(() => this.icon() == 'VolCoordination');
	public readonly volRecruitmentToolbar = computed(() => this.icon() == 'VolRecruitment');
	public readonly deliveryToolbar = computed(() => this.icon() == 'Delivery');
	public readonly alumniToolbar = computed(() => this.icon() == 'Alumni');
	public readonly developementToolbar = computed(() => this.icon() == 'Development');
	public readonly experienceToolbar = computed(() => this.icon() == 'Experience');


	public readonly iconAndTitle = computed(() => {
		if (this.configurationToolbar()) return { icon: 'fa-folder-gear', title: 'Configuration Toolbar' };
		if (this.admissionsToolbar()) return { icon: 'fa-chart-diagram', title: 'Admissions Toolbar' };
		if (this.volCoordinationToolbar()) return { icon: 'fa-handshake', title: 'Volunteer Coordination Toolbar' };
		if (this.volRecruitmentToolbar()) return { icon: 'fa-user-tie', title: 'Volunteer Recuitment Toolbar' };
		if (this.deliveryToolbar()) return { icon: 'fa-folder-open', title: 'Delivery Toolbar' };
		if (this.alumniToolbar()) return { icon: 'fa-graduation-cap', title: 'Alumni Toolbar' };
		if (this.developementToolbar()) return { icon: 'fa-hand-holding-circle-dollar', title: 'Development Toolbar' };
		if (this.experienceToolbar()) return { icon: 'fa-clipboard-list-check', title: 'Experience Toolbar' };
		return undefined;
	});


}